import React from 'react';
import Navbar from '../lab/Navbar';
import Sidebar from '../lab/Sidebar';
import WalletContent from './WalletContent';
import './css/Wallet.css';

const Wallet = ({ isCollapsed, toggleSidebar }) => {
    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={3} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <WalletContent />
            </div>
        </div>
    );
};

export default Wallet;
